import { render, staticRenderFns } from "./Multiplayer.vue?vue&type=template&id=1987e25a&scoped=true&"
import script from "./Multiplayer.vue?vue&type=script&lang=ts&"
export * from "./Multiplayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987e25a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1987e25a')) {
      api.createRecord('1987e25a', component.options)
    } else {
      api.reload('1987e25a', component.options)
    }
    module.hot.accept("./Multiplayer.vue?vue&type=template&id=1987e25a&scoped=true&", function () {
      api.rerender('1987e25a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Multiplayer.vue"
export default component.exports